import { useRef, useCallback } from "react";

/**
 * Hook para evitar condiciones de carrera (race conditions) en peticiones asíncronas consecutivas.
 * Permite invalidar peticiones en vuelo y asegura que únicamente la respuesta de la última petición
 * iniciada aplique cambios en el estado del componente.
 */
export function useLatestRequest() {
  const latestRequestIdRef = useRef<number>(0);

  const getNextRequestId = useCallback((): number => {
    latestRequestIdRef.current += 1;
    return latestRequestIdRef.current;
  }, []);

  const isCurrent = useCallback((requestId: number): boolean => {
    return requestId === latestRequestIdRef.current;
  }, []);

  const invalidate = useCallback((): void => {
    latestRequestIdRef.current += 1;
  }, []);

  return {
    getNextRequestId,
    isCurrent,
    invalidate,
  };
}
